import { render, staticRenderFns } from "./rights.vue?vue&type=template&id=2728a00f&scoped=true"
import script from "./rights.vue?vue&type=script&lang=js"
export * from "./rights.vue?vue&type=script&lang=js"
import style0 from "./rights.vue?vue&type=style&index=0&id=2728a00f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2728a00f",
  null
  
)

export default component.exports